<template>
  <div>
    <form @submit.prevent="handleSubmit">
      <h4>Create a New Playlist</h4>
      <input type="text" placeholder="Playlist title" required v-model="title">
      <textarea placeholder="Playlist description..." required v-model="description"></textarea>
      <label>Upload Playlist Cover Image</label>
      <input type="file" @change="fileChange">
      <div class="error" v-if='fileError'>{{ fileError }}</div>
      <div class="error" v-if="error">{{ error }}</div>
      <button type='submit' v-if="isPending" disabled>Saving</button>
      <button type='submit' v-else>Create</button>
    </form>
  </div>
</template>

<script>
import { ref } from 'vue'
import useStorage from '../../composables/useStorage'
import useCollection from '../../composables/useCollection'
import getUser from '../../composables/getUser'
import { timestamp } from '../../firebase/config'
import { useRouter } from 'vue-router'

export default {
  setup() {
    const router = useRouter();
    const title = ref('');
    const description = ref('');
    const file = ref(null);
    const fileError = ref(null);
    const isPending = ref(false);

    const { error, addDoc } = useCollection('playlists');
    const { user } = getUser();
    const { uploadFile, url, filepath } = useStorage();

    const handleSubmit = async () => {
      if(file.value){
        isPending.value = true;
        await uploadFile(file.value);
        // addDoc return res 即加入資料庫的結果，document metadata
        const res = await addDoc({
          title: title.value,
          description: description.value,
          userId: user.value.uid,
          userName: user.value.displayName,
          coverUrl: url.value,
          filepath: filepath.value, //方便刪除用
          songs: [],
          createdAt: timestamp()
        });
        isPending.value = false;
        if(!error.value){
          // create完成立即轉到該detail頁，因此必須要有id
          // res  = document metadata
          router.push({ name: 'Playlistdetail', params: { id: res.id}});
        }
      }
    };
    const types = ['image/png', 'image/jpg', 'image/jpeg'];
    const fileChange = (e) => {
      const selected = e.target.files[0];
      // change事件，從target的files取出file
      // 確定有上傳（避免點了又取消）且符合格式
      console.log(selected);
      if(selected && types.includes(selected.type)){
        file.value = selected 
      } else {
        file.value = null;
        fileError.value = 'Please select an image file (png or jpg)'
      }
    };
    return { title, description, handleSubmit, fileChange, fileError, error, isPending }
  }
}
</script>

<style>
  form {
    background: white;
  }
  input[type="file"] {
    border: 0;
    padding: 0;
  }
  label {
    font-size: 12px;
    display: block;
    margin-top: 30px;
  }
  button {
    margin-top: 20px;
  }
</style>